import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import type { TFunction } from "i18next";

interface LanguageCardProps {
  language: string;
  editingLanguage: boolean;
  tempLang: string;
  onEditClick: () => void;
  onSaveClick: () => void;
  setTempLang: (lang: string) => void;
  t: TFunction<"translation", undefined>;
  compact?: boolean;
}

const LanguageCard: React.FC<LanguageCardProps> = ({
  language,
  editingLanguage,
  tempLang,
  onEditClick,
  onSaveClick,
  setTempLang,
  t,
  compact = false,
}) => {
  return (
    <Card className={`border h-full flex flex-col ${compact ? 'shadow-sm' : ''}`}>
      <CardHeader className={compact ? "pb-2 pt-4 px-4" : "pb-2"}>
        <CardTitle className={compact ? "text-base" : "text-xl"}>{t("language")}</CardTitle>
      </CardHeader>
      <CardContent className={`${compact ? 'text-xs px-4 pb-3' : 'text-sm sm:text-base md:text-lg'} text-[#4A5364] flex-1 flex flex-col`}>
        {editingLanguage ? (
          <>
            <div className="flex-1">
              <select
                className={`w-full border rounded p-1 ${compact ? 'text-xs' : 'text-xs sm:text-sm'} bg-white`}
                value={tempLang}
                onChange={(e) => setTempLang(e.target.value)}
              >
                <option value="es">Español</option>
                <option value="en">English</option>
              </select>
            </div>
            <div className="mt-auto">
              <div className={`h-px w-full bg-[#E4E4E7] ${compact ? 'my-2' : 'my-2 sm:my-4'}`} />
              <Button
                variant="link"
                className={`p-0 h-auto text-[#105BDB] ${compact ? 'text-xs' : ''}`}
                onClick={onSaveClick}
              >
                {t("save")}
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="flex-1">
              <p>{language === "es" ? "Español" : "English"}</p>
            </div>
            <div className="mt-auto">
              <div className={`h-px w-full bg-[#E4E4E7] ${compact ? 'my-2' : 'my-2 sm:my-4'}`} />
              <Button
                variant="link"
                className={`p-0 h-auto text-[#105BDB] ${compact ? 'text-xs' : ''}`}
                onClick={onEditClick}
              >
                {t("edit")}
              </Button>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default LanguageCard;
